import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
export const TOAST_FADE_DURATION = 350;
export default function Toast({ title, children, visible, close, autoCloseAfter, justNowText, }) {
    const [timestamp, setTimestamp] = useState(() => DateTime.now());
    const [formattedTimeAgo, setFormattedTimeAgo] = useState(null);
    const justNow = justNowText || 'just now';
    const [visibilityClass, setVisibilityClass] = useState(justNow);
    useEffect(() => {
        let timeout;
        if (visible) {
            setTimestamp(DateTime.now());
            setVisibilityClass('fade showing');
            timeout = window.setTimeout(() => {
                setVisibilityClass('fade show');
            }, TOAST_FADE_DURATION);
        }
        else {
            setVisibilityClass('fade');
            timeout = window.setTimeout(() => {
                setVisibilityClass('fade hide');
            }, TOAST_FADE_DURATION);
        }
        return () => {
            window.clearTimeout(timeout);
        };
    }, [visible]);
    useEffect(() => {
        if (visible) {
            const handle = window.setInterval(() => {
                if (autoCloseAfter && timestamp.diffNow('milliseconds').milliseconds >= autoCloseAfter) {
                    close();
                }
                if (timestamp.diffNow('minutes').minutes < 1) {
                    setFormattedTimeAgo(justNow);
                }
                else {
                    setFormattedTimeAgo(timestamp.toRelative());
                }
            }, 1000 * 15);
            return () => {
                window.clearInterval(handle);
            };
        }
    }, [timestamp, visible, close, autoCloseAfter, justNow]);
    return (_jsxs("div", Object.assign({ className: `toast ${visibilityClass}`, role: "alert", "aria-live": "assertive", "aria-atomic": "true" }, { children: [_jsxs("div", Object.assign({ className: "toast-header" }, { children: [_jsx("span", Object.assign({ className: "mr-auto flex-grow-1" }, { children: title })), _jsx("small", Object.assign({ className: "text-muted" }, { children: formattedTimeAgo })), _jsx("button", { type: "button", className: "ms-2 mb-1 btn-close", "data-dismiss": "toast", "aria-label": "Close", onClick: close })] })), _jsx("div", Object.assign({ className: "toast-body" }, { children: children }))] })));
}
//# sourceMappingURL=Toast.js.map